import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { gql } from "@/__generated__";
import Navbar from "@/components/layout/navbar/navbar";
import { ReferPatientProgressTracker } from "@/components/refer-patient-progress-tracker";
import { StrengthenReferral } from "../strengthen-referral/strengthen-referral";
import { DocumentsTab } from "../strengthen-referral/components/tabs/documents-tab/documents-tab";

export const GET_APPEAL_STATUS = gql(`
  query GetAppealStatusForDocuments($appealId: ID!) {
    appealStatus(appealId: $appealId) {
      referred
      currentStatus
    }
  }
`);

export function Documents() {
  const { appealId } = useParams<{ appealId: string }>();

  const { data } = useQuery(GET_APPEAL_STATUS, {
    variables: { appealId: appealId! },
    skip: !appealId,
    fetchPolicy: "no-cache",
  });

  const readOnly = data?.appealStatus?.referred ?? false;
  const currentStatus = data?.appealStatus?.currentStatus;

  if (!appealId) {
    return null;
  }

  return (
    <Navbar
      titleComponent={<ReferPatientProgressTracker appealId={appealId} />}
    >
      <StrengthenReferral
        appealId={appealId}
        activeTab="documents"
        tabContent={
          <DocumentsTab
            appealId={appealId}
            readOnly={readOnly}
            currentStatus={currentStatus}
          />
        }
      />
    </Navbar>
  );
}
